import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { createRef, Component } from 'react';
import windowWidth from '@outdoor-voices/ui/dist/utils/dom/windowWidth';
import { BREAK_TABLET_SMALL, SCROLL } from '../../config/constants';
import { Mission, Values, JoinUs } from './AboutSections';
import css from './About.module.scss';
import Footer from '../Footer';
import OVLogo from '../icons/OVLogo';
import scrollTop from '../../utils/dom/scrollTop';
import SubNav from './AboutSubNav';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var navHeight = 72;
var style = "\n  body:not(.scrolled) .".concat(css.fixedBackgroundTop, " {\n    background: none !important;\n  }\n\n  @media screen and (max-width: 667px) {\n    body.scrolled .").concat(css.stickyHeader, " {\n      top: ").concat(navHeight, "px;\n    }\n  }\n");

var About = /*#__PURE__*/function (_Component) {
  _inherits(About, _Component);

  var _super = _createSuper(About);

  function About(props) {
    var _this;

    _classCallCheck(this, About);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onScroll", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          getSectionOffsetTop = _assertThisInitialize.getSectionOffsetTop,
          isActiveSection = _assertThisInitialize.isActiveSection; // SECTION 0 - header


      var headerBreakPoint = _this.html.offsetHeight / 10;
      var missionBreakPoint = getSectionOffsetTop(_this.missionEl.current);

      var isActiveHeaderSection = _this.isActiveSection(headerBreakPoint, missionBreakPoint);

      if (isActiveHeaderSection) {
        _this.setState({
          activeSection: 0,
          scrolledPastHeader: true
        });

        return;
      } // SECTION 1 - mission


      var valuesBreakPoint = getSectionOffsetTop(_this.valuesEl.current);

      if (isActiveSection(missionBreakPoint, valuesBreakPoint)) {
        _this.setState({
          activeSection: 1,
          lockOverflowScroll: false
        });

        return;
      }

      var joinusBreakPoint = getSectionOffsetTop(_this.joinusEl.current);
      var topScroll = scrollTop(); // SECTION 2 - values

      if (isActiveSection(valuesBreakPoint, joinusBreakPoint)) {
        _this.setState({
          lockOverflowScroll: false
        });

        var scrollingDown = _this.state.scrollingDown;
        var stickyHeaderEl = _this.stickyHeaderEl.current;
        var scrollUpPadding = navHeight + stickyHeaderEl.offsetHeight * 2;
        var scrollUpBreakPoint = joinusBreakPoint - scrollUpPadding;

        if (!scrollingDown) {
          _this.setState({
            activeSection: 2
          });
        } else if (topScroll <= scrollUpBreakPoint) {
          _this.setState({
            activeSection: 2
          });
        } else {
          _this.setState({
            activeSection: 3
          });
        } // SECTION 4 - footer positioned to recreate seemless scroll -- check here for larger viewports


        if (topScroll > _this.calcFooterTop()) {
          _this.setState({
            lockOverflowScroll: true
          });
        }

        return;
      } // SECTION 3 - joinus


      if (topScroll > joinusBreakPoint) {
        _this.setState({
          activeSection: 3,
          lockOverflowScroll: false,
          scrollingDown: false
        }); // SECTION 4 - footer positioned to recreate seemless scroll -- check here for standard viewport heights.


        if (topScroll > _this.calcFooterTop()) {
          _this.setState({
            lockOverflowScroll: true
          });
        }

        return;
      }

      _this.setState({
        activeSection: 0,
        autoScrollingUp: false,
        scrollingDown: true,
        scrolledPastHeader: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubNavAnchorClick", function (e) {
      e.preventDefault(); // Mobile devices do not act as links.

      if (_this.isMobile()) return false;
      var anchorEl = e.currentTarget;

      _this.scrollToSection(anchorEl.getAttribute('id'));

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "getNextSection", function () {
      var _this$state = _this.state,
          activeSection = _this$state.activeSection,
          scrollingDown = _this$state.scrollingDown;
      var sections = _this.props.sections; // MISSION

      if (!activeSection) return 1; // Scroll back up to top - HEADER

      if (!scrollingDown) return 0; // VALUES & JOINUS - subtract 2 for Header && Footer Sections.

      if (activeSection < sections.length - 2) {
        return activeSection + 1;
      }

      return activeSection - 1;
    });

    _defineProperty(_assertThisInitialized(_this), "getSectionOffsetTop", function (sectionEl) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var stickyHeaderEl = _this.stickyHeaderEl.current;
      return sectionEl.offsetTop - stickyHeaderEl.offsetHeight - navHeight - offset;
    });

    _defineProperty(_assertThisInitialized(_this), "setHash", function () {
      var sectionName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _window$location = window.location,
          pathname = _window$location.pathname,
          search = _window$location.search;
      var newHash = sectionName.length ? "".concat(pathname).concat(search, "#").concat(sectionName) : "".concat(pathname).concat(search);
      window.history.pushState({}, '', newHash);
      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "scrollToSection", function (sectionName) {
      var sectionEl = _this["".concat(sectionName, "El")].current; // Offset: Two, 3px top-borders.


      var offset = -6;

      var top = _this.getSectionOffsetTop(sectionEl, offset);

      _this.smoothScroll(top);

      _this.setHash(sectionName);

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "scrollNext", function (e) {
      e.preventDefault();
      var scrollingDown = _this.state.scrollingDown;

      if (!scrollingDown) {
        _this.smoothScroll(0);

        _this.setState({
          autoScrollingUp: true
        });

        return 0;
      }

      var sections = _this.props.sections;

      var nextSection = sections[_this.getNextSection()].id;

      _this.scrollToSection(nextSection);

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "smoothScroll", function () {
      var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      window.scrollTo({
        behavior: 'smooth',
        top: top
      });
    });

    _defineProperty(_assertThisInitialized(_this), "calcFooterTop", function () {
      return _this.footerEl.current.offsetTop - window.innerHeight + _this.subNavEl.current.offsetHeight;
    });

    _defineProperty(_assertThisInitialized(_this), "isActiveSection", function (topSection, bottomSection, sectionNum) {
      var activeSection = _this.state.activeSection;
      var topScroll = scrollTop();
      return topScroll > topSection && topScroll < bottomSection && activeSection !== sectionNum;
    });

    _defineProperty(_assertThisInitialized(_this), "isMobile", function () {
      return BREAK_TABLET_SMALL > windowWidth();
    });

    _this.joinusEl = /*#__PURE__*/createRef();
    _this.missionEl = /*#__PURE__*/createRef();
    _this.footerEl = /*#__PURE__*/createRef();
    _this.rootEl = /*#__PURE__*/createRef();
    _this.stickyHeaderEl = /*#__PURE__*/createRef();
    _this.subNavEl = /*#__PURE__*/createRef();
    _this.valuesEl = /*#__PURE__*/createRef();
    _this.state = {
      activeSection: props.activeSection,
      autoScrollingUp: false,
      lockOverflowScroll: false,
      scrollingDown: true,
      scrolledPastHeader: false
    };
    return _this;
  }

  _createClass(About, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var sections = this.props.sections;
      this.html = document.documentElement;
      window.addEventListener(SCROLL, this.onScroll); // Scroll to section (if not first-section).

      var hash = window.location.hash;

      if (hash.length && sections.find(function (section) {
        return section.id === hash;
      })) {
        this.scrollToSection(hash.replace('#', '').trim());
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener(SCROLL, this.onScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          image = _this$props.image,
          sections = _this$props.sections;
      var _this$state2 = this.state,
          activeSection = _this$state2.activeSection,
          autoScrollingUp = _this$state2.autoScrollingUp,
          lockOverflowScroll = _this$state2.lockOverflowScroll,
          scrollingDown = _this$state2.scrollingDown,
          scrolledPastHeader = _this$state2.scrolledPastHeader;
      var arrowIconClass = cc([css.downArrow, _defineProperty({}, css.scrollingUp, !scrollingDown || activeSection >= 3), _defineProperty({}, css.autoScrollingUp, autoScrollingUp)]);
      var backgroundImageStyle = {
        backgroundImage: "url(".concat(image, ")")
      };
      var rootClass = cc([css.root, _defineProperty({}, css.lockOverflowScroll, lockOverflowScroll)]);
      return /*#__PURE__*/_jsxs("div", {
        className: rootClass,
        ref: this.rootEl,
        children: [/*#__PURE__*/_jsx("style", {
          dangerouslySetInnerHTML: {
            __html: style
          }
        }), /*#__PURE__*/_jsx("div", {
          className: css.fixedBackground,
          style: backgroundImageStyle
        }), /*#__PURE__*/_jsxs("h1", {
          className: css.stickyHeader,
          ref: this.stickyHeaderEl,
          children: [/*#__PURE__*/_jsx("div", {
            className: cc([css.fixedBackground, css.fixedBackgroundTop]),
            style: backgroundImageStyle
          }), /*#__PURE__*/_jsx("i", {
            children: "We are "
          }), /*#__PURE__*/_jsx(OVLogo, {
            className: css.ovLogo
          }), /*#__PURE__*/_jsx("div", {
            className: cc([css.borderBottom, _defineProperty({}, css.titleBottomBorder, activeSection > 0)])
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: css.sectionContainer,
          children: [/*#__PURE__*/_jsx("section", {
            className: css.sectionIntro,
            children: /*#__PURE__*/_jsxs("p", {
              className: cc(_defineProperty({}, css.scrolledPastHeader, scrolledPastHeader || activeSection > 0)),
              children: [/*#__PURE__*/_jsx("span", {
                children: "The Recreation brand built with\xA0"
              }), /*#__PURE__*/_jsx("span", {
                className: css.noWordBreak,
                children: /*#__PURE__*/_jsx("i", {
                  children: "Recreationalists\xA0"
                })
              }), /*#__PURE__*/_jsx("span", {
                children: "like you in mind."
              })]
            })
          }), /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              className: css.section,
              ref: this.missionEl,
              children: /*#__PURE__*/_jsx(Mission, {})
            }), /*#__PURE__*/_jsx("li", {
              className: css.section,
              ref: this.valuesEl,
              children: /*#__PURE__*/_jsx(Values, {})
            }), /*#__PURE__*/_jsx("li", {
              className: css.section,
              ref: this.joinusEl,
              children: /*#__PURE__*/_jsx(JoinUs, {})
            })]
          })]
        }), /*#__PURE__*/_jsx(SubNav, {
          activeSection: activeSection,
          arrowIconClass: arrowIconClass,
          backgroundImageStyle: backgroundImageStyle,
          scrollNext: this.scrollNext,
          onSubNavAnchorClick: this.onSubNavAnchorClick,
          scrollingDown: scrollingDown,
          sections: sections,
          forwardedRef: this.subNavEl
        }), /*#__PURE__*/_jsx("div", {
          className: css.aboutUsFooter,
          ref: this.footerEl,
          children: /*#__PURE__*/_jsx(Footer, {
            source: "about",
            withEmail: true
          })
        })]
      });
    }
  }]);

  return About;
}(Component);

About.displayName = 'About';
About.propTypes = {
  activeSection: PropTypes.number.isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  image: PropTypes.string.isRequired
};
export default About;